export default "__VITE_ASSET__CcxBq5ka__"